import { Stack, Chip } from "@mui/material"
import { If } from "lib/@components/switch"

export function DataQualityWarnings({ costResult }) {
    if (!costResult) return null

    const unmapped = costResult.unmappedSkills?.count || 0
    const unpriced = costResult.unpricedTrades?.count || 0
    const unassigned = costResult.unassignedSkills?.count || 0
    const phantom = costResult.phantomCostTasks?.count || 0
    const hasWarnings = unmapped > 0 || unpriced > 0 || unassigned > 0 || phantom > 0

    if (!hasWarnings) return null

    return (
        <Stack direction="row" sx={{ flexWrap: "wrap", gap: 0.5 }}>
            <If value={unmapped > 0}>
                <Chip
                    label={`${unmapped} unmapped`}
                    size="small"
                    color="warning"
                    variant="outlined"
                    sx={{ height: 22, fontSize: 11 }}
                />
            </If>
            <If value={unpriced > 0}>
                <Chip
                    label={`${unpriced} unpriced`}
                    size="small"
                    color="warning"
                    variant="outlined"
                    sx={{ height: 22, fontSize: 11 }}
                />
            </If>
            <If value={unassigned > 0}>
                <Chip
                    label={`${unassigned} unassigned`}
                    size="small"
                    color="info"
                    variant="outlined"
                    sx={{ height: 22, fontSize: 11 }}
                />
            </If>
            <If value={phantom > 0}>
                <Chip
                    label={`${phantom} phantom`}
                    size="small"
                    color="info"
                    variant="outlined"
                    sx={{ height: 22, fontSize: 11 }}
                />
            </If>
        </Stack>
    )
}
